import { render, staticRenderFns } from "./SendApprovalAction.vue?vue&type=template&id=0711e5f6&scoped=true"
import script from "./SendApprovalAction.vue?vue&type=script&lang=js"
export * from "./SendApprovalAction.vue?vue&type=script&lang=js"
import style0 from "./SendApprovalAction.vue?vue&type=style&index=0&id=0711e5f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0711e5f6",
  null
  
)

export default component.exports